var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"sec-description"},[_vm._v(_vm._s(_vm.$t('diagnostic.consume.title'))),_c('br'),(_vm.sectionDescription)?_c('i',[_vm._v(_vm._s(_vm.sectionDescription))]):_vm._e()]),_c('apexchart',{staticClass:"canvas",attrs:{"width":_vm.size,"height":"600","type":"radar","options":_vm.chartOptions,"series":_vm.consume}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }